module.exports = __webpack_public_path__ + "img/2.3e8cfc91.jpg";